export default "__VITE_ASSET__Dkp1wLAY__"